import { BLOOM_RESOLUTION_SETTING, BLOOM_NUMBER_SETTINGS } from "flavr-common";
export { BLOOM_RESOLUTION_SETTING, BLOOM_NUMBER_SETTINGS };
export function getBloomResolutionScale(preferences) {
    var _a;
    const value = (_a = preferences.getNumberPreferredValue("bloomResolution", BLOOM_RESOLUTION_SETTING.default)) !== null && _a !== void 0 ? _a : BLOOM_RESOLUTION_SETTING.default;
    return ((Number.isFinite(value) ? Math.max(BLOOM_RESOLUTION_SETTING.min, Math.min(BLOOM_RESOLUTION_SETTING.max, value)) : BLOOM_RESOLUTION_SETTING.default) / 100);
}
export const BLOOM_PREFERENCE_SCHEMA = {
    useBloom: { type: "boolean", default: true },
    bloomResolution: { type: "number", default: BLOOM_RESOLUTION_SETTING.default },
    bloomStrength: { type: "number", default: BLOOM_NUMBER_SETTINGS.bloomStrength.default },
    bloomRadius: { type: "number", default: BLOOM_NUMBER_SETTINGS.bloomRadius.default },
    bloomThreshold: { type: "number", default: BLOOM_NUMBER_SETTINGS.bloomThreshold.default }
};
export function isBloomPreference(key) {
    return Object.prototype.hasOwnProperty.call(BLOOM_PREFERENCE_SCHEMA, key);
}
export function getBloomSettings(preferences) {
    const read = (key) => {
        var _a;
        const config = BLOOM_NUMBER_SETTINGS[key];
        const value = (_a = preferences === null || preferences === void 0 ? void 0 : preferences.getNumberPreferredValue(key, config.default)) !== null && _a !== void 0 ? _a : config.default;
        return Number.isFinite(value) ? Math.max(config.min, Math.min(config.max, value)) : config.default;
    };
    return { strength: read("bloomStrength"), radius: read("bloomRadius"), threshold: read("bloomThreshold") };
}
